export default __webpack_public_path__ + "static/media/icono-Estacion-titulo.fef44d66.svg";